import { styled } from 'styled-components';

import { RETAILER_COLORS, SHADOWS } from '@components/web/src/styles';

export const ProductFeedbackListItemContainer = styled.button`
  all: unset;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: start;
  cursor: pointer;
`;

export const ProductRateIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: ${RETAILER_COLORS.primary['25']};
  border-radius: 50%;
  box-shadow: ${SHADOWS.md};
`;
